import { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { log } from "../../utils/logger";
import "./Anketa.css";

export const ResetPassword = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = searchParams.get("token") || "";

    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [fieldErrors, setFieldErrors] = useState<Record<string, string>>({});
    const [message, setMessage] = useState<{ type: "success" | "error"; text: string } | null>(null);
    const [endpointAddress, setEndpointAddress] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        fetch("/config.json")
            .then((res) => res.json())
            .then((config) => {
                if (config["endpoint-address"]) setEndpointAddress(config["endpoint-address"]);
                log("ResetPassword", "Загружен config", { hasEndpoint: !!config["endpoint-address"] });
            })
            .catch((err) => log("ResetPassword", "Ошибка загрузки config", err));
    }, []);

    const validate = (): Record<string, string> => {
        const err: Record<string, string> = {};
        if (!newPassword.trim()) err.newPassword = "Введите новый пароль";
        else if (newPassword.length < 6) err.newPassword = "Пароль должен быть не менее 6 символов";
        if (newPassword !== confirmPassword) err.confirmPassword = "Пароли не совпадают";
        return err;
    };

    const handleSubmit = async () => {
        setMessage(null);
        if (!token.trim()) {
            setMessage({ type: "error", text: "Отсутствует ссылка для сброса. Запросите сброс пароля снова." });
            return;
        }
        const errors = validate();
        setFieldErrors(errors);
        if (Object.keys(errors).length > 0) {
            log("ResetPassword", "Валидация не пройдена", errors);
            return;
        }
        if (!endpointAddress) {
            setMessage({ type: "error", text: "Сервис временно недоступен." });
            return;
        }

        log("ResetPassword", "Отправка нового пароля");
        setSubmitting(true);
        try {
            const res = await fetch(`${endpointAddress}/resetPassword`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ token, newPassword }),
            });
            const data = await res.json().catch(() => ({}));
            log("ResetPassword", "Ответ сервера", { status: res.status, data });

            if (data.status === "1") {
                setMessage({ type: "success", text: data.message || "Пароль успешно изменён. Войдите с новым паролем." });
                setTimeout(() => navigate("/login"), 2000);
                return;
            }
            setMessage({ type: "error", text: (data.message as string) || "Ошибка сброса пароля. Ссылка могла истечь — запросите новую." });
        } catch (err) {
            log("ResetPassword", "Ошибка соединения", err);
            setMessage({ type: "error", text: "Ошибка соединения. Попробуйте позже." });
        } finally {
            setSubmitting(false);
        }
    };

    if (!token) {
        return (
            <div className="anketa-container">
                <div className="register-card">
                    <div className="question-section">
                        <h2 className="question-text">Неверная ссылка</h2>
                        <p className="question-hint">Отсутствует токен сброса. Перейдите по ссылке из письма или запросите сброс пароля снова.</p>
                    </div>
                    <div className="navigation-section">
                        <button className="nav-btn prev-btn" onClick={() => navigate("/forgot-password")} type="button">
                            Запросить сброс
                        </button>
                        <button className="nav-btn submit-btn" onClick={() => navigate("/login")} type="button">
                            К входу
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="anketa-container">
            <div className="register-card">
                <div className="question-section">
                    <h2 className="question-text">Новый пароль</h2>
                    <p className="question-hint">Введите новый пароль и подтвердите его.</p>
                </div>

                <div className="form-section">
                    <div className="form-group">
                        <label>Новый пароль</label>
                        <div className="password-input-wrapper">
                            <input
                                type={showPassword ? "text" : "password"}
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                placeholder="Не менее 6 символов"
                            />
                            <button
                                type="button"
                                className="password-toggle-btn"
                                onClick={() => setShowPassword(!showPassword)}
                                title={showPassword ? "Скрыть пароль" : "Показать пароль"}
                            >
                                {showPassword ? "👁️" : "👁️‍🗨️"}
                            </button>
                        </div>
                        {fieldErrors.newPassword && <div className="field-error">{fieldErrors.newPassword}</div>}
                    </div>
                    <div className="form-group">
                        <label>Подтверждение пароля</label>
                        <input
                            type={showPassword ? "text" : "password"}
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            placeholder="Повторите пароль"
                        />
                        {fieldErrors.confirmPassword && <div className="field-error">{fieldErrors.confirmPassword}</div>}
                    </div>
                    {message && (
                        <div
                            className="field-error"
                            style={{
                                marginTop: "0.5rem",
                                color: message.type === "success" ? "var(--success, #22c55e)" : "var(--error)",
                            }}
                        >
                            {message.text}
                        </div>
                    )}
                </div>

                <div className="navigation-section">
                    <button className="nav-btn prev-btn" onClick={() => navigate("/login")} type="button">
                        ← К входу
                    </button>
                    <button
                        className="nav-btn submit-btn"
                        onClick={handleSubmit}
                        type="button"
                        disabled={submitting}
                    >
                        {submitting ? "Сохранение..." : "Сохранить пароль"}
                    </button>
                </div>
            </div>
        </div>
    );
};
